import React from 'react'
import Select from 'react-select'

export default ({
  value,
  onChange,
  onBlur,
  ...props
}) => (
  <Select
    {...props}
    value={value || ''}
    onBlur={() => {}}
    onChange={(options, items) => {
      if (!Array.isArray(options)) {
        options = [options]
      }
      onChange(options.map(option => option.value))
    }}
  />
)



// WEBPACK FOOTER //
// ./src/components/forms/redux-select.js